import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    accordion: {
      marginBottom: theme.spacing(1),
      '&:before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: `${theme.spacing(1)}px 0`,
      },
    },
    accordionSummary: {
      backgroundColor: theme.palette.grey[50],
      '&.Mui-expanded': {
        backgroundColor: theme.palette.grey[100],
      },
      '& .MuiAccordionSummary-content': {
        margin: theme.spacing(1, 0),
        '&.Mui-expanded': {
          margin: theme.spacing(1, 0),
        },
      },
    },
    accordionDetails: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
    eventName: {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    label: {
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
      color: theme.palette.text.primary,
    },
    value: {
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1),
    },
    noResults: {
      textAlign: 'center',
      padding: theme.spacing(4),
      color: theme.palette.text.secondary,
    },
    paginationContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
  })
);

export default useStyles;